export const REASON_CLICK_AWAY = 'clickaway';
export const REASON_CLICK_CLOSE = 'clickclose';
export const REASON_TIMEOUT = 'timeout';
